module.exports = __webpack_public_path__ + "da55e778c0af59e1b7ba6a65bd7c986b.svg";